import { render, staticRenderFns } from "./VlActionDetailModal.vue?vue&type=template&id=0da66167&scoped=true&"
import script from "./VlActionDetailModal.vue?vue&type=script&lang=js&"
export * from "./VlActionDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da66167",
  null
  
)

export default component.exports